export const SD_COLORS = {
  navy: '#003177',
  skyBlue: '#ABD9FF',
  neonYellow: '#F3FD4A',
  forestGreen: '#328206',
  softPink: '#FFE2E6',
  orange: '#FF7A00',
  cream: '#FDF5EB',
  white: '#FFFFFF',
  black: '#000000',
} as const;

export const SD_FONTS = {
  display: '"Monument Extended", "Roboto", sans-serif',
  body: '"Inter", "Roboto", sans-serif',
} as const;

/** Monument Extended Regular — avoid Ultrabold (700) unless explicitly needed */
export const SD_DISPLAY_FONT_WEIGHT = 400;

/** Monument Extended reads large — slightly smaller root; body text uses px helpers instead. */
export const SD_HTML_FONT_SIZE = 14;

/** Flat px reduction for hardcoded font sizes (via getThemeFontSize / useSdFontSize). */
export const SD_FONT_SIZE_REDUCTION = 4;

/** Floor so very small defaults stay readable after reduction. */
export const SD_MIN_FONT_SIZE = 8;

/** Used by MUI theme.typography.fontFamily for Sport District booking flows */
export const SD_MUI_FONT_FAMILY = SD_FONTS.display;

export const SD_COPY = {
  monogram: 'sportsdistrict.',
  brandName: 'Sport District',
  tagline: 'Play, Train, Connect',
  headline: 'Where Every Game Builds Community',
  subheadline: 'Elevate Your Game, Enrich Your Life',
  featuredTag: 'SUMMER 2026 · FAN ZONE',
  featuredTitle: '2026 FAN ZONE',
  featuredDescription:
    'Every match live on the big screen — food, padel between games, and the whole community.',
  featuredCtaLabel: 'Book tickets now',
  sportSectionTitle: 'CHOOSE YOUR SPORT',
  bookCourtLabel: 'Book a court',
  location: 'Dhahran, KSA',
  communityTagline: 'SPORTS · WELLNESS · COMMUNITY',
  communityHeadline: 'WHERE EVERY GAME BUILDS COMMUNITY',
  locationCity: 'Dhahran, KSA',
  locationSubtitle: 'Eastern Province · open daily',
  findUsLabel: 'Find us here',
  address: '4268 King Saud Bin Abdulaziz Rd, Dhahran 34232, Saudi Arabia',
  registrationPrompt:
    'Create your profile to book classes and events at Sports District.',
} as const;

export type SDSportColorKey = keyof Pick<
  typeof SD_COLORS,
  'navy' | 'skyBlue' | 'neonYellow' | 'forestGreen' | 'softPink'
>;
